"use client";
import {useRouter} from 'next/navigation';
import {TickerSearchInput} from '@/components/ticker-search-input';
import {trackBiteEvent} from '@/lib/bite-measurement';
import {rememberPreparation} from './bite-recent-reports';
import {BiteReportSearchBackdrop} from './bite-report-search-backdrop';

export function BiteReportSearch({compact=false}:{compact?:boolean}={}) {
  const router=useRouter();
  const openTicker=(ticker:string)=>{
    try{trackBiteEvent('search',{ticker,...(compact?{placement:'report_header'}:{})});}catch{}
    rememberPreparation(ticker);
    router.push(`/bite/${encodeURIComponent(ticker)}`);
  };
  return <section className={`bite-report-search${compact?' bite-report-search--compact':''}`} aria-label="다른 기업 분석">
    <BiteReportSearchBackdrop/>
    <div className="bite-report-search__copy"><h2>하락장, 어떻게 대응할까?</h2>
      <p>목표가 / 익절가 / 손절가 분석해드립니다.</p></div>
    <TickerSearchInput autoFocus={false} onSelect={openTicker} resolveCompanyNames
      placeholder="티커 혹은 기업명을 입력하세요." submitLabel="보고서 보기" className="bd-ticker-search"/>
  </section>;
}
